<template>
  <div class="organization-chart-skeleton">
    <UISkeleton :static variant="semi-dark" class="organization-chart-skeleton__item" />
    <div class="organization-chart-skeleton__branch">
      <div class="organization-chart-skeleton__branch-item" />
      <div class="organization-chart-skeleton__branch-item organization-chart-skeleton__branch-item--middle" />
      <div class="organization-chart-skeleton__branch-item" />
    </div>
    <div class="organization-chart-skeleton__level">
      <UISkeleton :static variant="semi-dark" class="organization-chart-skeleton__item" />
      <UISkeleton :static variant="semi-dark" class="organization-chart-skeleton__item" />
      <UISkeleton :static variant="semi-dark" class="organization-chart-skeleton__item" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { UISkeleton } from '@ui/skeletons'

type Props = {
  static?: boolean
}

defineProps<Props>()
</script>

<style>
:root {
  --vue3-org-chart-line-color: #d1d5db;
}

:root[class~='dark'] {
  --vue3-org-chart-line-color: #4b5563;
}

.organization-chart-skeleton {
  @apply p-4;
  @apply flex flex-col items-center;

  &__item {
    @apply w-24 sm:w-48 aspect-video;
    @apply rounded-md;
  }

  &__level {
    @apply flex;
    @apply gap-x-2 sm:gap-x-4;
  }

  &__branch {
    @apply w-[13rem] sm:w-[26rem];
    @apply mt-2 sm:mt-4;
    @apply flex justify-between;
    @apply border-t border-[var(--vue3-org-chart-line-color)];
  }

  &__branch-item {
    @apply w-px h-2;
    @apply bg-[var(--vue3-org-chart-line-color)];

    &--middle {
      @apply h-4 sm:h-6;
      @apply -mt-2 sm:-mt-4;
    }
  }
}
</style>
